<template>
    <section class="section">
        <div class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                {{ nbProjects }} projets
            </h1>

            <b-field grouped>
                <b-field label="Filtre rapide sur les projets">
                    <b-input type="text"
                             v-model="filterP"
                             @input="searchP()">
                    </b-input>
                </b-field>
                <b-field label="Filtre rapide sur les responsables">
                    <b-input type="text"
                             v-model="filterR"
                             @input="searchR()">
                    </b-input>
                </b-field>
                <b-field label="Passer le PDF en paysage avec commentaires">
                    <b-switch v-model="exportComments">

                    </b-switch>
                </b-field>
                <b-field label="Statut">
                    <b-field>
                      <b-checkbox
                          size="is-medium"
                          v-model="showOnlyWaiting"
                          @input="showWaitingproject()"
                      >
                        Montrer les projets à valider
                      </b-checkbox>
                    </b-field>
                </b-field>

            </b-field>

            <hr>

            <!-- Table -->
            <b-table :data="list"
                     detailed
                     paginated
                     per-page="15"
                     custom-detail-row
                     detail-key="project"
                     show-detail-icon

            >
                <b-table-column field="partition" label="Projet" sortable v-slot="props">
                    <b>{{ props.row.project }}</b>
                </b-table-column>

                <b-table-column field="date" label="Dernière modification">
                    -
                </b-table-column>

                <b-table-column field="phase" label="Phase">
                    -
                </b-table-column>
                <b-table-column field="pj" label="Pièces-jointes">
                    -
                </b-table-column>

                <b-table-column field="edit" label="Editer">
                    -
                </b-table-column>

                <b-table-column field="clone" label="Cloner">
                    -
                </b-table-column>

                <b-table-column field="addphase" label="Ajouter une phase">
                    -
                </b-table-column>
                <b-table-column field="delete" label="Supprimer la phase">
                    -
                </b-table-column>
                <b-table-column field="owner" label="Responsable" v-slot="props">
                    <b>{{ props.row.user }}</b>
                </b-table-column>
                <b-table-column field="pdf" label="Générer le PDF" v-slot="props">
                    <b-button
                        type="is-info"
                        icon-right="file"
                        size="is-small"
                        @click.prevent="generatePDF(props.row.project, props.row.project, 'pdf', true, exportComments)">
                    </b-button>
                </b-table-column>

                <!-- Set a status to wait the final validation -->
                <b-table-column field="waiting" label="Statut" v-slot="props">
                  <b-button
                      type="is-warning"
                      icon-right="clock"
                      v-if="props.row.waiting && !props.row.validation"
                      :disabled="!props.row.canReqValidation && !canValidate"
                      size="is-small"
                      @click.prevent="requestValidation(props.row.project, false)">
                      En validation
                  </b-button>
                  <b-button
                      type="is-light"
                      icon-right="eye"
                      v-if="!props.row.waiting && !props.row.validation"
                      :disabled="!props.row.canReqValidation"
                      size="is-small"
                      @click.prevent="requestValidation(props.row.project, true)">
                      En édition
                  </b-button>
                  <b-button
                      type="is-success"
                      icon-right="check"
                      disabled
                      v-if="props.row.validation"
                      size="is-small"
                      >
                      Validé
                  </b-button>
                </b-table-column>

                <!-- The final validation by the director -->
                <b-table-column field="validate" label="Intégration" v-slot="props">
                    {{ props.row.validated }}
                    <b-button
                        type="is-success"
                        icon-right="check"
                        v-if="props.row.validation"
                        size="is-small"
                        disabled
                        @click.prevent="validate(props.row.project, false)">
                        Validé
                    </b-button>
                    <b-button
                        type="is-danger"
                        icon-right="times"
                        v-if="!props.row.validation && props.row.waiting"
                        :disabled="!canValidate"
                        size="is-small"
                        @click.prevent="validate(props.row.project, true)">
                        Non validé
                    </b-button>
                </b-table-column>

                <template slot="detail" slot-scope="props">
                    <tr v-for="item in props.row.object" :key="item.id">
                        <td></td>
                        <td class="has-text-right">
                            {{ item.fullName }}
                            <span v-if="item.dossiers">
                                <br/>
                                <b-taglist>
                                    <b-tag
                                        v-for="dossier in item.dossiers"
                                        :key="dossier"
                                        icon="folder"
                                        type="is-info">
                                        {{ dossier }}
                                    </b-tag>
                                </b-taglist>
                            </span>
                        </td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.phase }}</td>
                        <td>
                            <b-button
                                      type="is-dark"
                                      size="is-small"
                                      icon-right="paperclip"
                                      @click="displayAttach(item)">
                            </b-button>
                        </td>
                        <td>
                            <b-button
                                v-if="item.edit"
                                type="is-warning"
                                :disabled="props.row.validation || props.row.waiting"
                                icon-right="pen"
                                size="is-small"
                                @click.prevent="load(item.id)">
                            </b-button>
                        </td>
                        <td>
                            <b-button
                                type="is-info"
                                icon-right="copy"
                                size="is-small"
                                @click.prevent="copy(item.id)">
                            </b-button>
                        </td>
                        <td>
                            <b-button
                                type="is-success"
                                icon-right="plus-square"
                                :disabled="props.row.validation || props.row.waiting"
                                size="is-small"
                                @click.prevent="addPhase(item.id)">
                            </b-button>
                        </td>
                        <td>
                            <b-button
                                v-if="item.edit"
                                type="is-danger"
                                icon-right="trash"
                                :disabled="props.row.validation || props.row.waiting"
                                size="is-small"
                                @click.prevent="deletePhase(item.id)">
                            </b-button>
                        </td>
                        <td>
                                {{ item.user }}
                        </td>
                        <td>
                            <b-button
                                type="is-primary"
                                icon-right="file"
                                size="is-small"
                                @click.prevent="generatePDF(item.id, item.id, 'pdf', false, exportComments)">
                            </b-button>
                        </td>

                        <td></td>
                        <td></td>

                    </tr>
                </template>

            </b-table>

            <b-modal :active.sync="isAttachmentsModalActive" has-modal-card>
                <Attachments
                    :docid="docid"
                    :docadd="docadd"
                ></Attachments>
            </b-modal>

        </div>
    </section>
</template>

<script>

import Attachments from "./Attachments";

export default {
    name: 'Liste',
    components: {Attachments},
    mounted() {
        this.getList();
    },
    computed: {
        nbProjects() {
            return this.listOrigin.length;
        },
    },
    methods: {
        showWaitingproject() {
          if (this.showOnlyWaiting) {
            this.list = this.listOrigin.filter(i => i.waiting === true && i.validation === false);
          } else {
            this.list = this.listOrigin;
          }
        },
        requestValidation(project, state) {
            this.$buefy.dialog.confirm({
                message: `Êtes-vous sûr de changer le statut ?`,
                cancelText: 'Annuler',
                confirmText: 'Confirmer',
                onConfirm: () => {
                    this.reqValidations.push({project: project, waiting: state});
                    this.pushRequests();
                    this.reqValidations = [] // Reset
                }
            })
            /*
            this.reqValidations = this.reqValidations.filter(el => {
                  return el.project !== project;
                }
            );
            this.listOrigin.find(item => item.project === project).waiting = state;
            this.reqValidations.push({project: project, waiting: state});
            */
        },
        validate(project, validated) {
            if (this.canValidate) {
                this.$buefy.dialog.confirm({
                    message: `Êtes-vous sûr de valider le projet complet ? Il sera alors intégré automatique dans l'ERP !`,
                    cancelText: 'Annuler',
                    confirmText: 'Confirmer',
                    onConfirm: () => {
                        this.validations.push({project: project, validated: validated});
                        this.pushValidations();
                        this.validations = [];
                  }
              })
              /*
              this.validations = this.validations.filter(el => {
                    return el.project !== project;
                  }
              );
              this.listOrigin.find(item => item.project === project).validation = validated;
              this.validations.push({project: project, validated: validated});
              */

            } else {
                this.$buefy.snackbar.open({
                    duration: 3000,
                    message: 'Vous n\'êtes pas autorisé à valider les projets',
                    type: 'is-danger',
                    position: 'is-bottom-left',
                })
            }
        },
        pushRequests(){
            this.$axios.post('saveRequests', {
              requests: this.reqValidations
            })
                .then(rez => {
                  this.$buefy.dialog.alert({
                    message: `${rez.data.r} changement de statut enregistré`,
                    onConfirm: () => {
                      this.getList();
                    }
                  })
                })
                .catch(e => {
                  console.log(e);
                });
        },
        pushValidations() {
            this.$axios.post('saveValidations', {
                validations: this.validations
            })
                .then(rez => {
                    this.$buefy.dialog.alert({
                        message: `${rez.data.r} validation enregistrée`,
                        onConfirm: () => {
                            this.getList();
                        }
                    })
                })
                .catch(e => {
                    console.log(e);
                });
        },
        searchP() {
            this.filterR = '';
            if (this.filterP.length > 1) {
                const reg = new RegExp(`${this.filterP}`, 'i');
                this.list = this.listOrigin.filter(i => i.project.match(reg));
            } else {
                this.list = this.listOrigin;
            }
        },
        searchR() {
            // TODO : refaire ce truc de gitan
            this.filterP = '';
            if (this.filterR.length > 4) {
                this.list = [];
                let l = this.listOrigin;
                const reg = new RegExp(`${this.filterR}`, 'i');
                l.forEach(p => {
                    let arr = p.object.filter(d => d.user.match(reg));
                    let tempP = p;
                    tempP.object = arr;
                    this.list.push(tempP)
                })
                this.list = this.list.filter(i => i.object.length > 0);
            } else if (this.filterR.length === 0) {
                this.getList();
            }
        },
        generatePDF(id, nom, type, multiphase = false, comments = false) {
            this.$axios.get(`pdf?id=${id}&type=${type}&multiphase=${multiphase}&comments=${comments}`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept': 'application/pdf'
                    }
                })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${nom}.pdf`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }.bind(this))
                .catch(error => console.log(error));
        },
        displayAttach(i) {
            this.isAttachmentsModalActive = true;
            this.docid = i.id
            this.docadd = i.edit
        },
        getList() {
            this.$axios.get(`list`)
                .then(function (response) {
                    this.list = response.data.list;
                    this.listOrigin = this.list;
                    this.canValidate = response.data.canValidate;
                }.bind(this))
                .catch(error => console.log(error));
        },
        load(id) {
            this.$axios.get(`doc?id=${id}`)
                .then(function (response) {
                    localStorage.clear()
                    // Store attachment stub
                    localStorage.setItem("_attachments", JSON.stringify(response.data.doc._attachments));
                    // Store de _rev to update the doc
                    localStorage.setItem("_rev", JSON.stringify(response.data.doc._rev));
                    // Store de _id to update the doc
                    localStorage.setItem("_id", JSON.stringify(response.data.doc._id));
                    // Load project info
                    localStorage.setItem("project", JSON.stringify(response.data.doc.project));
                    localStorage.setItem("td", JSON.stringify(response.data.doc.td ? response.data.doc.td : []));
                    localStorage.setItem("fm", JSON.stringify(response.data.doc.fm ? response.data.doc.fm : []));
                    localStorage.setItem("mat", JSON.stringify(response.data.doc.mat ? response.data.doc.mat : []));
                    localStorage.setItem("sst", JSON.stringify(response.data.doc.sst ? response.data.doc.sst : []));
                    localStorage.setItem("fi", JSON.stringify(response.data.doc.fi ? response.data.doc.fi : []));
                    localStorage.setItem("p1", JSON.stringify(response.data.doc.p1 ? response.data.doc.p1 : ""));
                    localStorage.setItem("p2", JSON.stringify(response.data.doc.p2 ? response.data.doc.p2 : ""));
                    // Push to edit
                    this.$router.push('/projet')
                }.bind(this))
                .catch(error => console.log(error));
        },
        copy(id) {
            this.$axios.get(`doc?id=${id}`)
                .then(function (response) {
                    localStorage.clear()
                    response.data.doc.project.name = ""; // Reset name
                    response.data.doc.project.readablename = ""; // Reset name
                    localStorage.setItem("project", JSON.stringify(response.data.doc.project));
                    localStorage.setItem("td", JSON.stringify(response.data.doc.td ? response.data.doc.td : []));
                    localStorage.setItem("fm", JSON.stringify(response.data.doc.fm ? response.data.doc.fm : []));
                    localStorage.setItem("mat", JSON.stringify(response.data.doc.mat ? response.data.doc.mat : []));
                    localStorage.setItem("sst", JSON.stringify(response.data.doc.sst ? response.data.doc.sst : []));
                    localStorage.setItem("fi", JSON.stringify(response.data.doc.fi ? response.data.doc.fi : []));
                    localStorage.setItem("p1", JSON.stringify(response.data.doc.p1 ? response.data.doc.p1 : ""));
                    localStorage.setItem("p2", JSON.stringify(response.data.doc.p2 ? response.data.doc.p2 : ""));
                    this.$router.push('/projet')
                }.bind(this))
                .catch(error => console.log(error));
        },
        addPhase(id) {
            this.$axios.get(`doc?id=${id}`)
                .then(function (response) {
                    localStorage.clear()
                    // Reset phase and clone in local storage
                    response.data.doc.project.phase = "";
                    localStorage.setItem("project", JSON.stringify(response.data.doc.project));
                    // Clone folders
                    // TODO if needed
                    // Redirect to Saisie
                    this.$router.push('/projet')
                }.bind(this))
                .catch(error => console.log(error));
        },
        deletePhase(id) {
            this.$buefy.dialog.confirm({
                title: `Suppression de la phase`,
                confirmText: "Oui, je confirme",
                type: "is-danger",
                hasIcon: true,
                message: `La suppression d'une phase est irréversible, êtes-vous sûr de vouloir supprimer cette phase ?`,
                onConfirm: () => {
                    this.$axios.get(`removeDoc?id=${id}`)
                        .then(function () {
                            // console.log(response.data)
                            this.getList();
                        }.bind(this))
                        .catch(error => console.log(error));
                }
            });
        },
    },
    data() {
        return {
            showOnlyWaiting: false,
            canValidate: null,
            reqValidations: [],
            validations: [],
            list: [],
            listOrigin: [],
            isAttachmentsModalActive: false,
            docid: null,
            docadd: false,
            filterP: '',
            filterR: '',
            exportComments: false,
        }
    }
}
</script>

<style scoped>

.container {
    max-width: 100%;
    padding-left: 5%;
    padding-right: 5%;
}

</style>

